
if (!customElements.get('bfcm-deals')) {
  class BfcmDeals extends HTMLElement {
    constructor() {
      super();
      this._swiperInstance = null;
      this.columnsDesktop = Number(this.getAttribute("data-columns-desktop") ?? 4);
      this.columnsMobile = Number(this.getAttribute("data-columns-mobile") ?? 1.6);
      this.disableMobileSwiper = this.getAttribute("data-disable-mobile-swiper") == "true";
      this._swiperContainer = this.querySelector('.swiper-container');

      if (!this.disableMobileSwiper || window.innerWidth >= 768) {
        this.createSlider();
      }
    }

    createSlider() {
      const nextButton = this.querySelector('.swiper-btn-next');
      const prevButton = this.querySelector('.swiper-btn-prev');
      const pagination = this.querySelector(`.swiper-pagination`);

      this._swiperInstance = new Swiper(this._swiperContainer, {
        slidesPerView: 4,
        spaceBetween: '5%',
        loop: false,
        observer: true,
        resizeObserver: true,
        noSwiping: true,
        direction: "horizontal",
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
        breakpoints: {
          990: {  
            slidesPerView: this.columnsDesktop,
            spaceBetween: 20,
          },
          767: {  
            slidesPerView: this.columnsMobile,
            spaceBetween: 20,
          },
          589: {  
            slidesPerView: this.columnsMobile,
            spaceBetween: 20,
          },
        }
      });

      if (window.innerWidth <= 768){
        this._swiperInstance.noSwiping = false;
        const items =this._swiperContainer.querySelectorAll(".swiper-slide");
        items.forEach(item => {
          item.classList.remove("swiper-no-swiping")
        })
      }
    }

    destroySwiper() {
      this._swiperInstance.destroy();
    }
  }

  customElements.define('bfcm-deals', BfcmDeals);
}